import { Badge } from '@/components/ui/badge'
import { PropTypes } from 'prop-types'

const RewardsBadge = ({ rule }) => {
  return (
    <Badge variant="outlined" className="border-[1px] border-[--neutral-50] text-xs font-medium rounded-[6px]">
      <span className="ml-1 text-neutral-700">{rule}</span>
    </Badge>
  )
}

RewardsBadge.propTypes = {
  rule: PropTypes.string,
}

export default RewardsBadge
